module.exports = __webpack_public_path__ + "static/barco1-90335c122c8547a513fb4034bd81e3e8.jpg";